import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Users } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Industries', path: '/industries' },
    { name: 'Why Work With Us', path: '/why-us' },
    { name: 'Contact', path: '/contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 bg-[#0a1628] border-b border-[#1a2840]">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_skilled-talent/artifacts/6dw6qhl0_31811.jpg" 
              alt="S2S Logo" 
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
                  isActive(link.path)
                    ? 'text-[#d4a574] bg-[#1a2840]'
                    : 'text-gray-300 hover:text-white hover:bg-[#1a2840]'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          {/* CTA Buttons - All 4 options */}
          <div className="hidden lg:flex items-center space-x-2">
            <Link to="/contact?type=hire">
              <Button className="bg-[#d4a574] text-[#0a1628] hover:bg-[#c49564]">
                I Want to Hire Talent
              </Button>
            </Link>
            <Link to="/contact?type=resume">
              <Button variant="outline" className="border-[#d4a574] text-[#d4a574] hover:bg-[#d4a574] hover:text-[#0a1628]">
                I'm Looking for a Job
              </Button>
            </Link>
            <Link to="/contact?type=referral">
              <Button variant="outline" className="border-[#d4a574] text-[#d4a574] hover:bg-[#d4a574] hover:text-[#0a1628] relative">
                <Users className="mr-1" size={16} />
                Submit a Referral
              </Button>
            </Link>
            <Link to="/contact">
              <Button variant="outline" className="border-gray-500 text-gray-400 hover:bg-gray-700 hover:text-white">
                General Inquiry
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden text-white p-2"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t border-[#1a2840]">
            <nav className="flex flex-col space-y-2">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsMenuOpen(false)}
                  className={`px-4 py-3 text-sm font-medium rounded-md transition-colors ${
                    isActive(link.path)
                      ? 'text-[#d4a574] bg-[#1a2840]'
                      : 'text-gray-300 hover:text-white hover:bg-[#1a2840]'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <div className="flex flex-col space-y-2 pt-4 px-4">
                <Link to="/contact?type=hire" onClick={() => setIsMenuOpen(false)}>
                  <Button className="w-full bg-[#d4a574] text-[#0a1628] hover:bg-[#c49564]">
                    I Want to Hire Talent
                  </Button>
                </Link>
                <Link to="/contact?type=resume" onClick={() => setIsMenuOpen(false)}>
                  <Button variant="outline" className="w-full border-[#d4a574] text-[#d4a574] hover:bg-[#d4a574] hover:text-[#0a1628]">
                    I'm Looking for a Job
                  </Button>
                </Link>
                <Link to="/contact?type=referral" onClick={() => setIsMenuOpen(false)}>
                  <Button variant="outline" className="w-full border-gray-500 text-gray-300 hover:bg-gray-700">
                    <Users className="mr-2" size={16} />
                    Submit a Referral
                  </Button>
                </Link>
                <Link to="/contact" onClick={() => setIsMenuOpen(false)}>
                  <Button variant="outline" className="w-full border-gray-500 text-gray-300 hover:bg-gray-700">
                    General Inquiry
                  </Button>
                </Link>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
